import React, { useId } from 'react';

// Small variant of MatchbackEmptyStateIcon (packages/web/src/assets/audience/MatchbackEmptyStateIcon.tsx),
// used in the Create matchback modal's "Comparing against" empty state.
const MatchbackCompareEmptyStateIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg width="81" height="66" viewBox="0 0 81 66" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="33" cy="33" r="33" fill="#DAF2FF" />
      <circle cx="59.5" cy="33" r="20.15" stroke={`url(#${gradientId})`} strokeWidth="1.7" strokeDasharray="2 2" />
      <circle cx="59.5" cy="33" r="20.15" stroke="white" strokeOpacity="0.1" strokeWidth="1.7" strokeDasharray="2 2" />
      <defs>
        <linearGradient id={gradientId} x1="38.5" y1="15.9375" x2="83.8303" y2="23.4768" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1784EC" />
          <stop offset="0.5" stopColor="#FF8FA1" />
          <stop offset="1" stopColor="#FF6C0A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MatchbackCompareEmptyStateIcon;
